<template>
    <v-row>
        <v-col>           
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between px-3">   
                                    <img class="ma-1- mx-0 mt-5"  src="/mstile-70x70.png" height="36" />
                                    <h5 class="ma-1 ml-4 mt-6" >Campaign Performance Report</h5> 
                                </div> 
                                <v-autocomplete class="ml-4"   label="Select Campaign" v-model="selectedCampaignID" :items="campaignOptions"></v-autocomplete>
                                <div class="d-flex flex"></div>
                                <v-btn class="maz-4 mr-4 mt-4" color="white" style="color: black" @click="exportDocument(selectedCampaignID)" :loading="progressStatsLoading">
                                        <v-icon>mdi-file-document-outline</v-icon>
                                        Export
                                </v-btn>
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="loadEverything" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4"
                        />
                    </base-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="headerCols">                    
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>    
                                <div class="body-2" style="color: white">
                                    Campaign                                                            
                                </div>                                                            
                                <v-list-item-title class="headline mb-1 font-weight-bold">
                                    {{campaign_label}}                                                                  
                                </v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info ml-10-"
                                            >
                                            <span>{{start}}</span> 
                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> 
                                            <span>{{end}}</span> 
                                            <span>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-chip                                                                                                          
                                                    class="mr-4 rounded-pill"    
                                                    small
                                                    color="#4caf50"                         
                                                    label                                            
                                                    text-color="white"
                                                >
                                                    <!-- <v-icon small left>mdi-check</v-icon> -->
                                                    {{status}}
                                                </v-chip>
                                            </span>  
                                            </span>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col :cols="headerCols">                    
                    <card-dashboard :primaryvalue="brand" :valueformatting="'text'" secondaryvalue="Brands" ></card-dashboard>
                </v-col>
                <v-col v-if="budgetAmount" :cols="headerCols">
                    <card-dashboard title="" :primaryvalue="budgetAmount" unit="€" valueformatting="currency" secondaryvalue="Budget" ></card-dashboard>
                </v-col>
            </v-row>

            <v-row v-if="placementPlan && placementPlan.length > 0">
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pr-3">
                            <v-card-title>Offline Placement Plan</v-card-title>
                        </div>
                    </base-card>
                </v-col>
            </v-row>            

            





            <v-row v-if="placementPlan && placementPlan.length > 0"> 
                <v-col cols="12" class="pb-0">
                    <div style="padding-right: 20px;">
                        <apexchart
                            width="100%"
                            :height="100 * placementPlan.length"
                            type="rangeBar"
                            :options="placementPlanChartOptions"
                            :series="placement_plan_adapted"
                        />
                    </div>                    
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="mt-3">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pr-3">
                            <v-card-title>Performance</v-card-title>
                        </div>
                    </base-card>
                </v-col>
            </v-row>      


            <v-row> 
                <v-col cols="12">
                    <div class="metrics-grid">
                        <div class="metrics-griditem" style="grid-column: 1 / span 2; grid-row: 1;">
                            <card-dashboard title="Total Impressions" :primaryvalue="totalImpressions" unit="imp." ></card-dashboard>
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 3 / span 2; grid-row: 1;">
                            <card-dashboard title="True Impressions" :primaryvalue="trueImpressions" unit="imp." ></card-dashboard>
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 5 / span 2; grid-row: 1;">
                            <card-dashboard title="Total Clicks" :primaryvalue="totalClicks" unit="clicks" ></card-dashboard>
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 7 / span 2; grid-row: 1;">
                            <card-dashboard title="Other Events" :primaryvalue="totalEvents" unit="events"  ></card-dashboard>
                        </div> 
                        <div class="metrics-griditem" style="grid-column: 1 / span 2; grid-row: 2;">
                            <card-dashboard title="CTR" :primaryvalue="ctrPct" unit="" valueformatting="percent" ></card-dashboard>
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 3 / span 2; grid-row: 2;">
                            <card-dashboard title="TCTR" :primaryvalue="tctrPct" unit="" valueformatting="percent" ></card-dashboard>

                        </div>   
                    </div>                    
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">                    
                    <base-card>
                        <div class="d-flex align-center justify-space-between pr-3">
                            <v-card-title>&nbsp;</v-card-title>
                        </div>                          
                        <v-card-text style="display: flex">
                            <v-progress-circular   
                                v-if="loading_chartandtotals"
                                style="margin-bottom: 50px; margin-left: auto; margin-right: auto; align-self: center"                                                     
                                indeterminate
                                color="black"
                        ></v-progress-circular>
                        <div v-else style="width: 100%">
                            <apexchart
                            type="line"
                            width="100%"
                            height="365"
                            :options="adaptDailyDataToLineChart(totalDailyStats, dailyTotalsLineChartValueListMapOptions).chartOptions"
                            :series="adaptDailyDataToLineChart(totalDailyStats, dailyTotalsLineChartValueListMapSeries).series"
                            />
                        </div>                            
                        </v-card-text>
                    </base-card>
                </v-col>                                            
            </v-row>

            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-text>
                            <v-tabs>
                                    <v-tab >Physical Devices</v-tab>
                                    <v-tab>Web Placement</v-tab>                                                                   
                                    <v-tab-item transition="false">
                                        <div>                                     
                                            <div style="display: flex; align-items:center;" class="mt-2">
                                                <span class="mx-4  v-label theme--light- mt-1">Group By: </span>
                                                <v-checkbox                                                    
                                                    v-model="groupByDate"
                                                    @change="reloadPhysicalDevicesTable"
                                                    label="Date"                                                 
                                                    hide-details="true"   
                                                    class="mt-0 mr-4 "                                                                                                                                                            
                                                />
                                                <v-checkbox                                                    
                                                    v-model="groupByDeviceType"
                                                    @change="reloadPhysicalDevicesTable"
                                                    label="Placement Type"                                                 
                                                    hide-details="true"           
                                                    class="mt-0 mr-4"                                                                                                 
                                                />
                                                <v-checkbox                                                    
                                                    v-model="groupByStore"
                                                    @change="reloadPhysicalDevicesTable"
                                                    label="Store"                                                 
                                                    hide-details="true"     
                                                    class="mt-0 mr-4"                                                                                                       
                                                />
                                                <span v-if="groupByStore" class="mx-4  v-label theme--light- mt-1" style="color: rgba(255, 255, 255, 0.7) !important;">Filter By Store Selection: </span>                                                
                                                <v-combobox      
                                                    v-if="groupByStore"                                                                   
                                                    v-model="storeStatsFilter_selectedStores"
                                                    :items="storeStatsFilter_StoresList"                                                                    
                                                    label="All Stores"      
                                                    outlined                                           
                                                    hide-details
                                                    single-line                       
                                                    dense       
                                                    style="max-width: 400px;"
                                                    :clearable="true"   
                                                    multiple    
                                                    @blur="reloadPhysicalDevicesTable"                                                                                           
                                                />
                                            </div>                                                                              
                                                <div style="display: flex;">         
                                                    <v-progress-circular   
                                                        v-if="loading_physicaldevices"
                                                        style="margin-left: auto; margin-right: auto; margin-top: 40px; margin-bottom: 40px;"                                                     
                                                        indeterminate
                                                        color="black"
                                                    ></v-progress-circular>                                               
                                                    <v-simple-table v-else style="display: block; width: 100%">
                                                        <thead>
                                                            <tr>
                                                                <th>Placement Type</th>
                                                                <th>Store</th>
                                                                <th v-if="groupByDate">Date</th>
                                                                <th v-if="!groupByDate">Start Date</th>
                                                                <th v-if="!groupByDate">End Date</th>
                                                                <th>Impressions</th>
                                                                <!--<th>Events</th>-->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="tinytablelistt">                                        
                                                                    <tr v-for="(storeadpstat, idx) in storeAdpointStats" :key="idx">
                                                                        <td class="nobottomborder">{{ storeadpstat.devicetypedescr }}</td>
                                                                        <td class="nobottomborder">{{ storeadpstat.storeid == 'all' ? 'All' : storeadpstat.storeid + ' - ' + storeadpstat.storedescription }}</td>
                                                                        <td v-if="groupByDate" class="nobottomborder">{{ storeadpstat.refdate }}</td>
                                                                        <td v-if="!groupByDate" class="nobottomborder">{{ storeadpstat.startdate }}</td>
                                                                        <td v-if="!groupByDate" class="nobottomborder">{{ storeadpstat.enddate }}</td>
                                                                        <td class="nobottomborder">{{ formatInteger(storeadpstat.impressions) }}</td>
                                                                        <!--<td class="nobottomborder">{{ formatInteger(storeadpstat.events) }}</td>-->
                                                                    </tr>                                                                    
                                                        </tbody>
                                                    </v-simple-table>     
                                                </div>                                                                           
                                            </div>
                                    </v-tab-item>                         
                                    <v-tab-item transition="false">
                                        <v-radio-group
                                            v-model="showWebStatsCharts"    
                                            row    
                                            small
                                            class="ml-4"                            
                                        >
                                            <!--<v-radio
                                                label="Show Table"
                                                value="table"
                                                small
                                            ></v-radio>     
                                            <v-radio
                                                label="Show Chart"
                                                value="chart"
                                                small
                                            ></v-radio>     -->       
                                        </v-radio-group>                                        
                                        <div v-for="(oladpoint, index) in onlineAdpointsList" :key="oladpoint.id">                                                                             
                                                     <div><span style="font-weight: 700">ADPOINT:&nbsp;</span>{{oladpoint.id}}</div>                                                                                                   
                                                    <div style="display: block;">   
                                                        <v-data-table
                                                            style="display: block;"
                                                            :headers="webStatsHeaders"
                                                            :items="[onlineAdpointsList[index]]"
                                                            :single-expand="true"                                                            
                                                            item-key="id"
                                                            show-expand
                                                            class="elevation-1"
                                                            hide-default-footer
                                                        >
                                                            <template v-slot:top>                                                            
                                                            </template>
                                                            <template v-slot:expanded-item="{ item }">
                                                                <td colspan="5" class="ml-0 mr-0 pl-0 pr-0">
                                                                    <div v-if="showWebStatsCharts!='chart'" class="v-data-table">
                                                                        <div class="v-data-table__wrapper">
                                                                            <table style="width: 100%;">   
                                                                                <thead class="v-data-table-header" style="display: none;">
                                                                                    <tr>
                                                                                        <th class="text-start"></th>
                                                                                        <th class="text-start">Date</th>
                                                                                        <th class="text-start">Impressions</th>
                                                                                        <th class="text-start">Clicks</th>
                                                                                        <th class="text-start">Events</th>                                                                    
                                                                                    </tr>
                                                                                </thead>                                         
                                                                                <tbody>
                                                                                    <tr v-for="stat in item.stats" :key="stat.date + '_il'">
                                                                                        <td class="text-start" style="width: 56px; height: 36px;">                                                                                            
                                                                                        </td>
                                                                                        <td class="text-start" style="width: 22%; height: 36px;">{{ stat.date }}</td>
                                                                                        <td class="text-start" style="width: 22%; height: 36px;">{{ stat.impressions }}</td>
                                                                                        <td class="text-start" style="width: 22%; height: 36px;">{{ stat.clicks }}</td>
                                                                                        <td class="text-start" style="width: 22%; height: 36px;">{{ stat.events }}</td>                                                                            
                                                                                    </tr>  
                                                                                </tbody>                                                                  
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                    <base-card v-else>
                                                                        <!-- <div class="d-flex align-center justify-space-between pr-3">
                                                                            <v-card-title>Goal Tracking - {{stat.type}}</v-card-title>
                                                                        </div> -->
                                                                        <v-card-text>
                                                                            <apexchart
                                                                            type="line"
                                                                            width="100%"
                                                                            height="365"
                                                                            :options="adaptDailyDataToLineChart(item.stats).chartOptions"
                                                                            :series="adaptDailyDataToLineChart(item.stats).series"
                                                                            />
                                                                        </v-card-text>
                                                                    </base-card>
                                                                </td>                                                                                                                                    
                                                            </template>
                                                        </v-data-table>
                                                    </div>   
                                                    <br/>                                                                        
                                                    <br/>
                                            </div>                                        
                                    </v-tab-item>
                                    
                            </v-tabs>
                        </v-card-text>
                    </base-card>


                </v-col>
            </v-row>    
            <v-row>
                <v-col cols="12" v-if="campaign != null && campaign != '-'">
                    <report-rule-component :selectedCampaign="campaign"></report-rule-component>
                </v-col>
            </v-row>
            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >
                {{ mysnackbar_msg }}
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index"; 
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate, formatDateTimeLabel} from '@/core/date-utils.js';
import { formatInteger as formatIntegerLabel } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {
        return {            
            mysnackbar: false,
            mysnackbar_msg: "",  


            groupByDate: false,
            groupByStore: false,
            groupByDeviceType: true,

            loading_physicaldevices: true,
            loading_chartandtotals: true,

            showWebStatsCharts: 'table',
            expanded: [],
            webStatsHeaders: [
                {
                    text: 'Date',
                    align: 'start',
                    sortable: false,
                    value: 'date',
                    width: '22%'
                },
                {
                    text: 'Impressions',
                    align: 'start',
                    sortable: false,
                    value: 'impressions',
                    width: '22%'
                },
                {
                    text: 'Clicks',
                    align: 'start',
                    sortable: false,
                    value: 'clicks',
                    width: '22%'
                },
                {
                    text: 'Events',
                    align: 'start',
                    sortable: false,
                    value: 'events',
                    width: '22%'
                },
            ],

            storeStatsFilter_selectedStores: [{value: 'all', text: 'All Stores'}],

            storeStatsFilter_StoresList: [
                {
                    value: "all",
                    text: "All Stores"
                }
            ],


            selectedCampaignID: "",

            campaign: "-",
            campaign_label: "-",
            start: "",
            end: "",
            status: "",
            brand: "-",
            budgetAmount: null,
            budgetType: "-",
            goalAmount: null,            
            goalUnit: "",   

            totalImpressions: null,
            trueImpressions: null,
            clickableImpressions: null,
            totalClicks: null,
            totalEvents: null,
            ctrPct: '-',
            tctrPct: '-',

            placementPlan: [              
            ],

            totalDailyStats: [],


            onlineAdpointsList: [                         
            ],


            storeAdpointStats: [
            ],

            
            placementPlanChartOptions: {
                chart: {
                    height: 350,
                    type: 'rangeBar'
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        distributed: true,
                        dataLabels: {
                            hideOverflowingLabels: false
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function(val, opts) {
                        var label = opts.w.globals.labels[opts.dataPointIndex];
                        let info = opts.w.globals.initialSeries[opts.seriesIndex].data[opts.dataPointIndex];
                        var a = moment(val[0])
                        var b = moment(val[1])
                        //var c = this.placementPlan[opts.dataPointIndex].assetName;
                        var diff = b.diff(a, 'days')
                        return info.assetName + ' [' + diff + (diff > 1 ? ' days]' : ' day]')
                        //return c + ': ' + label + ': ' + diff + (diff > 1 ? ' days' : ' day')
                    },
                    style: {
                        colors: ['#f3f4f5', '#fff']
                    }
                },
                xaxis: {
                    type: 'datetime',
                    position: 'top'
                },
                yaxis: {
                    //show: false
                },
                grid: {
                    row: {
                        colors: ['#f3f4f5', '#fff'],
                        opacity: 1
                    }
                },
                tooltip: {
                    custom: function({series, seriesIndex, dataPointIndex, w}) {
                    let info = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                    return '<div style="padding: 5px; display: inline-flex; display: inline-flex;"><img src="' + info.assetThumbnailUrl + '" alt="" width="60" class="mr-4" /><span style="margin-top: 5px;" class="mr-4">' + info.assetName + '</span></div>';
                    }
                }
            },




            

            // selectedNetwork: null,
            // networkOptions: [],
            selectedCampaign: null,
            progressStats: null,
            progressStatsLoading: false,
            activityStatsLoading: false,

            campaignOptions: [],
            attributeOptions: [],
            brandOptions: [],
            deviceTypeOptions: [],
            selectedCalcInterval: 'Last 7 Days',
            calculationDate: [],
            calculationDatepicker: null,
            attributeToAdd: null,








            series: [70],
            chartOptions: {
                chart: {
                height: 120,
                type: "radialBar"
                },
                
            
                colors:["#33cc33"],
                plotOptions: {
                radialBar: {
                    hollow: {
                    margin: 0,
                    size: "40%"
                    },
                
                    dataLabels: {
                    show: true,
                    name: {
                        offsetY: 0,
                        show: false,
                        color: "green",
                        fontSize: "13px"
                    },
                    value: {
                        offsetY: 6,
                        color: "#828d99",
                        fontSize: "15px",
                        show: true,
                        fontWeight: 700,
                    }
                    }
                }
                },
            
                stroke: {
                lineCap: "round",
                },
                labels: ["Progress"]
            }, 
            
            series2: [24],
            chartOptions2: {
                chart: {
                height: 120,
                type: "radialBar"
                },
                
            
                colors:["#ff5c33"],
                plotOptions: {
                radialBar: {
                    hollow: {
                    margin: 0,
                    size: "40%"
                    },
                
                    dataLabels: {
                    show: true,
                    name: {
                        offsetY: 0,
                        show: false,
                        color: "green",
                        fontSize: "13px"
                    },
                    value: {
                        offsetY: 6,
                        color: "#828d99",
                        fontSize: "15px",
                        show: true,
                        fontWeight: 700,
                    }
                    }
                }
                },
            
                stroke: {
                lineCap: "round",
                },
                labels: ["Progress"]
            },



            totalItemCount: 0,
            totalItemCount_adp: 0,
            quicksearch: '',
            pagingOptions: {},
            pagingOptions_adp: {},
            selected: [],
            baseData: [],
            baseData_adp: [],
            select_field: null,
            select_operator: null,
            filtercriteria: null,
            filterfields: [],                    
            filtersVisible: true,
            headers: [
                {text: 'Event ID', align: 'start', value: 'id',  sortable: false},
                {text: 'Adpoint ID', align: 'start', value: 'adpointid',  sortable: false},
                // {text: 'Network', align: 'start', value: 'network',  sortable: false},                
                {text: 'Type', value: 'eventtype',  sortable: false},
                {text: 'Campaign', value: 'campaign',  sortable: false},
                // {text: 'Network', value: 'networkId',  sortable: false},                
                {text: 'Status', value: 'offline',  sortable: false},
                {text: 'Extra Data', value: 'data',  sortable: false},
                {text: 'Creation (UTC)', value: 'aud_create_date',  sortable: false},                                                
            ],
            headers_adp: [
                {text: 'Adpoint ID', align: 'start', value: 'adpointid',  sortable: false},                            
                // {text: 'Device Type', value: 'deviceId',  sortable: false},
                // {text: 'Capacity', value: 'nominalCapacity'},
                // {text: '', value: 'usedCapacity'},
                // {text: 'Status', value: 'status',  sortable: false},
                {text: 'Events Count', value: 'blob'},                
                // {text: '"Click" Events Count', value: 'clickeventscount'},
                {text: '', value: 'action'}                
            ]
        }
    },
    filters: {
        formatDate(value) {
            return formatDateTimeLabel(value);
        }
    },
    watch: {
      pagingOptions: {
        handler () {
          this.fetchGridData();
        },
        deep: true,
      },
      selectedCampaign() {
        this.fetchSelectedCampaignStatistics(this.selectedCampaign);
        this.fetchCampaignActivityAdpoints(this.selectedCampaign);
      },
      selectedCalcInterval() {
        this.fetchCampaignActivityAdpoints(this.selectedCampaign);
      },
      pagingOptions_adp: {
        handler () {
          this.fetchCampaignActivityAdpoints(this.selectedCampaign);
          //this.fetchGridData_adp();
        },
        deep: true,
      },
    //   quicksearch: function() {
    //       this.fetchGridData();
    //   }
    },
    computed: {
        downloadUrl() {
            return "";
            // let rslt = '/api/' + PATH.CAMPAIGN_DOWNLOADREPORT + '/' + this.$route.params.id;
            // return rslt;
        },
        dailyTotalsLineChartValueListMapSeries() {
            let otherCount = this.totalEvents;

            
            let rslt = [
                
                {
                    name: "Impressions",
                    color: '#FFA500',
                    valueProperty: 'impressions',
                },
                {
                    name: "True Impressions",
                    color: '#e815da',
                    valueProperty: 'trueimpressions',
                },
                {
                    name: "Clicks",
                    color: '#28C76E',
                    valueProperty: 'clicks',
                },
                {
                    name: "Other Events",
                    color: '#4287f5',
                    valueProperty: 'events',
                },
            ];
            if(otherCount == 0) {
                rslt = [                
                    {
                        name: "Impressions",
                        color: '#FFA500',
                        valueProperty: 'impressions',
                    },
                    {
                        name: "True Impressions",
                        color: '#e815da',
                        valueProperty: 'trueimpressions',
                    },
                    {
                        name: "Clicks",
                        color: '#28C76E',
                        valueProperty: 'clicks',
                    }
                ]
            }
            return rslt;
        },
        dailyTotalsLineChartValueListMapOptions() {
            let otherCount = this.totalEvents;

            let rslt = [
                {
                    name: "Other Events",
                    color: '#4287f5',
                    valueProperty: 'events',
                },
                {
                    name: "Impressions",
                    color: '#FFA500',
                    valueProperty: 'impressions',
                },
                {
                    name: "True Impressions",
                    color: '#e815da',
                    valueProperty: 'trueimpressions',
                },
                {
                    name: "Clicks",
                    color: '#28C76E',
                    valueProperty: 'clicks',
                },
                
                
            ];
            if(otherCount == 0) {
                rslt = [                    
                    {
                        name: "Impressions",
                        color: '#FFA500',
                        valueProperty: 'impressions',
                    },
                    {
                        name: "True Impressions",
                        color: '#e815da',
                        valueProperty: 'trueimpressions',
                    },
                    {
                        name: "Clicks",
                        color: '#28C76E',
                        valueProperty: 'clicks',
                    },
                    
                    
                ]
            }
            return rslt;
        },
        headerCols() {
            if(this.budgetAmount) {
                return 4;
            }
            return 6;
        },
        placement_plan_adapted() {
            let srcData = this.placementPlan;
            let todayDate = (new Date()).getTime();            
            return [{
                data: srcData.map((item)=> {
                    let eventStart = new Date(item.start.substring(0,10)).getTime();
                    let eventEnd = new Date(item.end.substring(0,10)).getTime();

                    const rslt = {
                        x: '#' + item.ruleNumber + ' placement', //+ item.assetType,
                        y: [
                            eventStart,
                            eventEnd,
                            //'something'
                        ],
                        fillColor: '#008FFB',
                        ...item,
                        ...(
                            eventStart<=todayDate && todayDate<=eventEnd ? {
                                goals: [
                                    {
                                        name: 'Break',
                                        value: todayDate,
                                        strokeColor: '#CD2F2A'
                                    }
                                ]
                            } : {}
                        )
                    };
                    return rslt;
                })
            }]
        },

        gridData() {
            const rspData = this.baseData;
            return this.formatListData(rspData);
        },
        gridData_adp() {
            const rspData = this.baseData_adp;
            return rspData;//this.formatListData(rspData);
        },
        filterColumnCount() {
            const d = this.filtersVisible;
            return (d ? 2 : 0);
        },
        gridColumnCount() {
            const d = this.filtersVisible;
            return (d ? 10 : 12);
        },
    },
    methods: {
        formatInteger(src) {
            if(src=='0' || src==0) {
            return 0;
            }
            return formatIntegerLabel(src);
        },
        formatDate(d) {
            return formatDate(d);
        },
        async reloadPhysicalDevicesTable() {
            try {
                this.loading_physicaldevices=true;
                this.storeAdpointStats.splice(0);
                const rsp2 = await api.campaign.getCampaignProgressReportDataPartB(
                    this.selectedCampaignID, 
                    {selectedStores: this.storeStatsFilter_selectedStores.map(s=>s.value), 
                        groupByDeviceType: this.groupByDeviceType, 
                        groupByStore: this.groupByStore, 
                        groupByDate: this.groupByDate,
                        phys: true
                    }
                );
                this.storeAdpointStats.push(...rsp2.data.storeAdpointStats);
            } catch (error) {
                
            } finally {
                this.loading_physicaldevices=false;
            }
            
        },
        async exportDocument(cmpnid) {
            try {
                this.progressStatsLoading=true;
                await srvApi.downloadfile(PATH.CAMPAIGN_DOWNLOADREPORT + '/' + cmpnid, "report_" + this.campaign.replace(' ', '_') + (new Date()).toISOString().substring(0,10));
            } catch (error) {
                
            }            
            finally {
                this.progressStatsLoading=false;
            }
            // this.progressStatsLoading = true;            
            // const rsp = await srvApi.downloadfile(PATH.CAMPAIGN_DOWNLOADREPORT + '/' + cmpnid);
            // this.progressStatsLoading = false;
            // this.mysnackbar=true;
        },

        async fetchSelectedCampaignStatistics(selectedCampaign) {
            if(!selectedCampaign) return;
            this.progressStatsLoading = true;
            let rsp = await api.campaign.getCampaignProgressStatistics(selectedCampaign);            
            this.progressStats = rsp.data;
            this.progressStatsLoading = false;            
        },
        async fetchCampaignActivityAdpoints(selectedCampaign) {
            if(!selectedCampaign) return;
            this.activityStatsLoading = true;
            let qs = '?' + this.convertSelectedCalcIntervalToQuerystringDates();
            let rsp = await api.campaign.getCampaignActivityAdpoints(selectedCampaign, qs);            
            this.totalItemCount_adp = rsp.data.total;

            this.fetchGridData();

            this.activityStatsLoading = false;            
        },
        generateRandomInteger(min, max)  {
            const diff = max - min;            
            return Math.floor(min + (Math.random() * diff));
        },
        getEventActivityGraphData(dailyData) {
            let serializedData = [];
            let reduced = [];
            if(dailyData) {
                for(let rule of dailyData) {
                serializedData = serializedData.concat(...rule.graphData);
                }
                reduced = serializedData.reduce(function(pV, cV, cI){
                    let existingItem = pV.find(a=>a.refdate == cV.tgtdate);
                    if(existingItem) {
                        existingItem['actual_amount'] += parseInt(cV['actual_amount']);
                    }
                    else {
                        let newItem = {refdate: cV.tgtdate, actual_amount: parseInt(cV.actual_amount)};
                        pV.push(newItem);
                    }
                    return pV;
                }, []);
            }
            let [start,end] = this.convertSelectedCalcIntervalToQuerystringDates(true);

            let rslt = {
                series: [
                    {
                    name: 'impression',
                    data: [...reduced.map(r=> { if(r.refdate <= end && r.refdate >= start) return r.actual_amount})], //[14, 29, 18, 30, 20, 40, 36],
                    },
                    // {
                    // name: 'click',
                    // data: [null, null, null, null, null, null, null],
                    // },
                ],
                chartOptions: {
                    chart: {
                    type: 'line',
                    height: 350,
                
                    toolbar: {
                        show: false,
                    },
                    },
                    dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 1,
                    },
                    colors: ['#5d78ff', '#fbaf0f', '#FF5CD3', '#444CF2', '#48DBBB', '#A6F244', '#FBAF0F'],
                    stroke: {
                    width: 7,
                    curve: 'smooth',
                    },

                    xaxis: {
                    categories: [...reduced.map(r=>{ if(r.refdate <= end && r.refdate >= start) return r.refdate })],//['Thu 30/06', 'Fri 01/07', 'Sat 02/07', 'Sun 03/07', 'Mon 04/07', 'Tue 05/07', 'Wed 06/07'],
                    title: {
                        text: '',
                    },
                    axisBorder: {
                        show: false,
                        },
                    },
                    yaxis: {
                    title: {
                        text: '',
                    },
                    min: 0,
                    // max: 40,
                    },
                    markers: {
                    size: 5,
                    hover: {
                        size: 7,
                    },
                    },
                    grid: {
                    
                    borderColor: 'transparent',
                    row: {
                        colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0,
                    },
                    },
                    legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    },
                },
            }
            return rslt;
        },
        adaptDailyDataToLineChart(dailyData, valueListMap=null, dateProperty="date") {
            if(!valueListMap) {
                valueListMap = [
                    {
                        name: "Impressions",
                        color: '#FFA500',
                        valueProperty: 'impressions',
                    },
                    // {
                    //     name: "True Impressions",
                    //     color: '#8e8da2',
                    //     valueProperty: 'trueimpressions',
                    // },
                    {
                        name: "Clicks",
                        color: '#28C76E',
                        valueProperty: 'clicks',
                    },
                    {
                        name: "Events",
                        color: '#4287f5',
                        valueProperty: 'events',
                    },
                ];
            }
            let targetDates = dailyData.map(d=>d[dateProperty]);
            let rslt = {                
                series: [],
                chartOptions: {
                    chart: {
                            height: 350,
                            type: 'line',
                            dropShadow: {
                                enabled: true,
                                color: '#000',
                                top: 18,
                                left: 7,
                                blur: 10,
                                opacity: 0.2,
                            },
                            toolbar: {
                                show: false,
                            },
                            },
                            colors: [],
                            stroke: {
                            width: [3, 3, 3 ,3],
                            curve: 'straight',
                            },
                            markers: {
                            size: [5,5,5,5],
                            },
                            dataLabels: {
                            enabled: false,
                            },
                            grid: {
                            strokeDashArray: 3,
                            },
                            xaxis: {
                            categories: targetDates,
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false,
                            },
                        },                              
                },
            }
            for(let i=0; i<valueListMap.length; i++) {
                let valueMapItem = valueListMap[i];
                rslt.series.push({
                    name: valueMapItem.name,
                    data: dailyData.map(d=>d[valueMapItem.valueProperty]),     
                    zIndex: valueMapItem.name == "Impressions" ? 20 : 10,
                });
                rslt.chartOptions.colors.push(valueMapItem.color);
            }
            return rslt;
        },
        getGoalTrackingGraphData(dailyData) {
            let actualTimeSeries = [];
            let targetTimeSeries = [];

            let actualTimeSeries_WebClick = [];
            let actualTimeSeries_WebTrueImpressions = [];

            let targetDates = [];
            if(dailyData && dailyData.graphData) {
                actualTimeSeries = dailyData.graphData.map(g=>g.actual_amount_running_total);
            }
            if(dailyData && dailyData.graphData) {
                targetTimeSeries = dailyData.graphData.map(g=>g.target_amount_running_total);
            }
            if(dailyData && dailyData.graphData) {
                targetDates = dailyData.graphData.map(g=>g.tgtdate);
            }

            if(dailyData && dailyData.graphDataWebClick) {
                actualTimeSeries_WebClick = dailyData.graphDataWebClick.map(g=>g.actual_amount_running_total);
            }
            if(dailyData && dailyData.graphDataWebTrueImpression) {
                actualTimeSeries_WebTrueImpressions = dailyData.graphDataWebTrueImpression.map(g=>g.actual_amount_running_total);
            }

            let rslt = {                
                series: [
                    {
                    name: 'Actual',
                    data: actualTimeSeries //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                    },                    
                ],
                chartOptions: {
                    chart: {
                            height: 350,
                            type: 'line',
                            dropShadow: {
                                enabled: true,
                                color: '#000',
                                top: 18,
                                left: 7,
                                blur: 10,
                                opacity: 0.2,
                            },
                            toolbar: {
                                show: false,
                            },
                            },
                            colors: ['#28C76E'],
                            stroke: {
                            width: [4, 3, 3 ,3],
                            curve: 'straight',
                            },
                            markers: {
                            size: [6, 0],
                            },
                            dataLabels: {
                            enabled: false,
                            },
                            grid: {
                            strokeDashArray: 3,
                            },
                            xaxis: {
                            categories: targetDates,
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false,
                            },
                        },                              
                },
            }

            if(!(dailyData && dailyData.graphDataWebClick && dailyData.graphDataWebTrueImpression)) {
                rslt.series.push({
                    name: 'Goal',
                    data: targetTimeSeries
                },);
                rslt.chartOptions.colors.push('#8e8da2'); 
            }
            

            if(dailyData && dailyData.graphDataWebClick) {
                rslt.series.push({
                    name: 'Click',
                    data: actualTimeSeries_WebClick //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                });
                rslt.chartOptions.colors.push('#FFA500');                
            }            

            if(dailyData && dailyData.graphDataWebTrueImpression) {
                rslt.series.push({
                    name: 'True Impression',
                    data: actualTimeSeries_WebTrueImpressions //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                });
                rslt.chartOptions.colors.push('#33adff');   
            }

            return rslt;
        },
        getRatioWidgetData(actual, target) {
            let ratio = Math.floor(actual / target * 100);   
                        
            let initData = {};
            initData = {
                    series: [ratio],
                    chartOptions: {
                        chart: {
                        height: 120,
                        type: "radialBar"
                        },                                    
                        colors:["#33cc33"],
                        plotOptions: {
                        radialBar: {
                            hollow: {
                            margin: 0,
                            size: "40%"
                            },                    
                            dataLabels: {
                            show: true,
                            name: {
                                offsetY: 0,
                                show: false,
                                color: (ratio >= 0 ? "green" : "red"),
                                fontSize: "13px"
                            },
                            value: {
                                offsetY: 6,
                                color: "#828d99",
                                fontSize: "15px",
                                show: true,
                                fontWeight: 700,
                            }
                            }
                        }
                        },
                    
                        stroke: {
                        lineCap: "round",
                        },
                        labels: ["Progress"]
                    }
                }
            
            return initData;            
        },
        onDeleteCondition(attrNameToDelete) {
            this.filterfields = this.filterfields.filter(f=>f.value != attrNameToDelete);
        },
        addCondition() {
            const selectedAttributeData = this.attributeOptions.find(o=>o.value==this.attributeToAdd);
            if(!selectedAttributeData) 
                return;            
            this.filterfields.push({
                value: selectedAttributeData.extra.name,
                text: selectedAttributeData.extra.description || selectedAttributeData.extra.name,
                criteria: {},
                type: selectedAttributeData.extra.type.startsWith('tag') ? "list" : "text",
                listItems: selectedAttributeData.extra.valuelist.map(i=> {return {value: i, text: i}})
            });  
            this.attributeToAdd = null;          
        },
        getOptionDescription(optionList, optionValue){
            let matchedItem = optionList.find(o=>o.value===optionValue);
            let rslt = optionValue
            if(matchedItem) {
                rslt = matchedItem.text;
            }
            return rslt;
        },
        formatListData(rspData) {
            const d = rspData.map(d => { 
                return {
                    ...d, 
                    fullname: d.firstName + ' ' + d.lastName,                    
                } })
            return d;
        },
        pad(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length-size);
        },
  
        getQueryDateString(srcDate) {
            return this.pad(srcDate.getFullYear(),4) + "-" + this.pad(srcDate.getMonth()+1, 2) + "-" + this.pad(srcDate.getDate(), 2) ;
        },
        convertSelectedCalcIntervalToQuerystringDates(returnDates=false) {
            let today = new Date();
            let currentDate = new Date(today.setDate(today.getDate() + 1).valueOf());    
            let oldDate = new Date(currentDate.valueOf());
            // if(this.selectedCalcInterval=='Custom Date Range') {
            //     return "calculationDate=" + this.calculationDate;
            // }
            // else 
            if (this.selectedCalcInterval=='Last 30 Days') {                
                oldDate.setDate(oldDate.getDate()-30);                
            }
            else if (this.selectedCalcInterval=='Last 20 Days') {
                oldDate.setDate(oldDate.getDate()-20);  
            }
            else if (this.selectedCalcInterval=='Last 15 Days') {
                oldDate.setDate(oldDate.getDate()-15);  
            }
            else if (this.selectedCalcInterval=='Last 10 Days') {
                oldDate.setDate(oldDate.getDate()-10);  
            }
            else if (this.selectedCalcInterval=='Last 7 Days') {
                oldDate.setDate(oldDate.getDate()-7);  
            }
            else if (this.selectedCalcInterval=='Last 5 Days') {
                oldDate.setDate(oldDate.getDate()-5);  
            }
            else if (this.selectedCalcInterval=='Last 3 Days') {
                oldDate.setDate(oldDate.getDate()-3);  
            }
            else if (this.selectedCalcInterval=='Yesterday') {
                currentDate.setDate(oldDate.getDate()-1);
                oldDate.setDate(oldDate.getDate()-1);  
            }
            if(!returnDates) {
                return "startdate=" + this.getQueryDateString(oldDate) + "&enddate=" + this.getQueryDateString(currentDate);
            }
            else {
                return [this.getQueryDateString(oldDate), this.getQueryDateString(currentDate)];
            }            
        },
        async fetchGridData() {  
            if(!this.selectedCampaign) {
                return;
            }          
            let qstr = "";
            //paging
            console.log("\nPAGING PAGING PAGING PAGING \n" + JSON.stringify(this.pagingOptions));
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagingOptions;
            const limit = itemsPerPage;
            const currentPage = page;
            qstr += "?currentPage=" + page + "&limit=" + limit;
            //sorting       
            //if(!qstr.includes("?")) qstr = "?" + qstr;
            for(let i=0; i<sortBy.length; i++) {                
                qstr += "&sortBy[" + i + "]=" + sortBy[i];                
            }
            //sorting                   
            for(let i=0; i<sortDesc.length; i++) {                
                qstr += "&sortDesc[" + i + "]=" + sortDesc[i];                
            }     
            //criteria
            //if(!qstr.includes("?")) qstr = "?" + qstr;
            if(this.filtercriteria && this.filtercriteria.qs) {                
                qstr += this.filtercriteria.qs;
            }      
            //quicksearch
            if(this.quicksearch && this.quicksearch.length > 2){
                //if(!qstr.includes("?")) qstr = "?" + qstr;
                qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
            } 
            qstr += "&campaignid=" + encodeURIComponent(this.selectedCampaign);     
            //alert(querystr);
            const rsp = await api.event.getList(qstr);                  
            this.baseData = rsp.data.data.map(d => { return {...d, 
                                                        //fullname: d.firstName + ' ' + d.lastName
                                                    } }); 
            this.totalItemCount = rsp.data.total;
        },
        async fetchGridData_adp() {    
            return;        
            let qstr = "";
            //paging
            console.log("\nPAGING PAGING PAGING PAGING \n" + JSON.stringify(this.pagingOptions_adp));
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagingOptions_adp;
            const limit = itemsPerPage;
            const currentPage = page;
            qstr += "?currentPage=" + page + "&limit=" + limit;
            //sorting       
            //if(!qstr.includes("?")) qstr = "?" + qstr;
            for(let i=0; i<sortBy.length; i++) {                
                qstr += "&sortBy[" + i + "]=" + sortBy[i];                
            }
            //sorting                   
            for(let i=0; i<sortDesc.length; i++) {                
                qstr += "&sortDesc[" + i + "]=" + sortDesc[i];                
            }     
            // //criteria
            // //if(!qstr.includes("?")) qstr = "?" + qstr;
            // if(this.filtercriteria && this.filtercriteria.qs) {                
            //     qstr += this.filtercriteria.qs;
            // }      
            // //quicksearch
            // if(this.quicksearch && this.quicksearch.length > 2){
            //     //if(!qstr.includes("?")) qstr = "?" + qstr;
            //     qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
            // }      
            // //alert(querystr);
            const rsp = await api.adpoint.getList(qstr);
            this.baseData_adp = rsp.data.data.map(d => { return {...d, 
                                                        //fullname: d.firstName + ' ' + d.lastName
                                                    } }); 
            this.totalItemCount_adp = rsp.data.total;
        },
        // toggleFilterView() {
        //     this.filtersVisible = ! this.filtersVisible
        // },
        onSearch() {
            //alert(JSON.stringify(this.filtercriteria, null, 2));
            //alert(JSON.stringify(this.filtercriteria.qs, null, 2));
            this.fetchGridData();
        },
        triggerQuicksearch() {
            // if (this.quicksearch && this.quicksearch.length > 2) {
            //     this.fetchGridData();
            // }      
            this.fetchGridData();       
        },
        async loadEverything(reloadCampaigns=true) {
            try {
                this.progressStatsLoading=true;
                //TODO - Should load only stores (locations) that correspond to the network that this campaign is targeting (is a location under a network? Probably not - but it should be under somthing... !!! )
                const rspInitData = await api.adpoint.getInitData();
                

                if(reloadCampaigns) {
                    //load / init campaigns selector dropdown...
                    //TODO - Should load only campaigns that this user can access 
                    const rspCmpnOptions = await srvApi.get(PATH.CAMPAIGN_ASOPTIONS);
                    this.campaignOptions.splice(0, this.campaignOptions.length);
                    this.campaignOptions.push(...rspCmpnOptions.data.map(d=>({value: d.value.toString(), text: d.text})));
                }                
                
                this.loading_chartandtotals=true;
                const rsp = await api.campaign.getCampaignProgressReportData(this.selectedCampaignID);        

                this.campaign = rsp.data.campaign;


                this.storeStatsFilter_StoresList.splice(0, this.storeStatsFilter_StoresList.length);                                
                //filter the available stores filter and show only those that have data
                const storeCodesWithData = await srvApi.get(PATH.REPORTING_CAMPAIGN_LOCATIONFILTERLIST + '/' + encodeURIComponent(this.campaign));
                //alert(JSON.stringify(storeCodesWithData.data));
                this.storeStatsFilter_StoresList.push(...rspInitData.data.locationOptions.filter(opt=> storeCodesWithData.data.map(st=>st.storeid).includes(opt.value)));
                this.campaign_label = rsp.data.campaign_label;
                this.start = rsp.data.start;
                this.end = rsp.data.end;
                this.status = rsp.data.status;                
                this.brand = rsp.data.brand;
                this.budgetAmount = rsp.data.budgetAmount;
                this.budgetType = rsp.data.budgetType;
                this.goalAmount = rsp.data.goalAmount;
                this.goalUnit = rsp.data.goalUnit;

                this.totalImpressions = rsp.data.totalImpressions;
                this.trueImpressions = rsp.data.trueImpressions;
                this.clickableImpressions = rsp.data.clickableImpressions;
                this.totalClicks = rsp.data.totalClicks;
                this.totalEvents = rsp.data.totalEvents;
                this.ctrPct = rsp.data.ctrPct;
                this.tctrPct = rsp.data.tctrPct;

                this.placementPlan.splice(0, this.placementPlan.length);
                this.placementPlan.push(...rsp.data.placementPlan);

                // this.onlineAdpointsList.splice(0);
                // this.onlineAdpointsList.push(...rsp.data.onlineAdpointsList);

                // this.storeAdpointStats.splice(0);
                // this.storeAdpointStats.push(...rsp.data.storeAdpointStats);

                this.totalDailyStats.splice(0, this.totalDailyStats.length);
                this.totalDailyStats.push(...rsp.data.totalDailyStats);
                this.loading_chartandtotals=false;


                this.loading_physicaldevices=true;
                const rsp2 = await api.campaign.getCampaignProgressReportDataPartB(this.selectedCampaignID, {selectedStores: this.storeStatsFilter_selectedStores.map(s=>s.value), groupByDeviceType: this.groupByDeviceType, groupByStore: this.groupByStore, groupByDate: this.groupByDate});

                this.onlineAdpointsList.splice(0, this.onlineAdpointsList.length);
                this.onlineAdpointsList.push(...rsp2.data.onlineAdpointsList);

                this.storeAdpointStats.splice(0, this.storeAdpointStats.length);
                this.storeAdpointStats.push(...rsp2.data.storeAdpointStats);
                this.loading_physicaldevices=false;
            } catch (error) {
                
            } finally {
                this.loading_chartandtotals=false;
                this.loading_physicaldevices=false;
                this.progressStatsLoading=false;
            }

        }
    },
    async created() {     
        //load / init campaigns selector dropdown...
        //TODO - Should load only campaigns that this user can access 
        const rspCmpnOptions = await srvApi.get(PATH.CAMPAIGN_ASOPTIONS);
        this.campaignOptions.splice(0, this.campaignOptions.length);
        this.campaignOptions.push(...rspCmpnOptions.data.map(d=>({value: d.value.toString(), text: d.text})));

        if(this.$route.params.id) {
            console.log(JSON.stringify({id: this.$route.params.id}));

            this.selectedCampaignID = this.$route.params.id;            
        }      
        else {
            if(this.campaignOptions.length>0) {
                this.selectedCampaignID = this.campaignOptions[0].value
            }
        }  

        await this.loadEverything(false);
        /*
        try {

            
            const rspInitData = await api.adpoint.getInitData();
            this.storeStatsFilter_StoresList.push(...rspInitData.data.locationOptions);


            this.selectedCampaignID = this.$route.params.id;
            this.loading_chartandtotals=true;
            const rsp = await api.campaign.getCampaignProgressReportData(this.selectedCampaignID);        

            this.campaign = rsp.data.campaign;
            this.start = rsp.data.start;
            this.end = rsp.data.end;
            this.status = rsp.data.status;
            this.brand = rsp.data.brand;
            this.budgetAmount = rsp.data.budgetAmount;
            this.budgetType = rsp.data.budgetType;
            this.goalAmount = rsp.data.goalAmount;
            this.goalUnit = rsp.data.goalUnit;

            this.totalImpressions = rsp.data.totalImpressions;
            this.trueImpressions = rsp.data.trueImpressions;
            this.clickableImpressions = rsp.data.clickableImpressions;
            this.totalClicks = rsp.data.totalClicks;
            this.totalEvents = rsp.data.totalEvents;
            this.ctrPct = rsp.data.ctrPct;
            this.tctrPct = rsp.data.tctrPct;

            this.placementPlan.splice(0);
            this.placementPlan.push(...rsp.data.placementPlan);

            // this.onlineAdpointsList.splice(0);
            // this.onlineAdpointsList.push(...rsp.data.onlineAdpointsList);

            // this.storeAdpointStats.splice(0);
            // this.storeAdpointStats.push(...rsp.data.storeAdpointStats);

            this.totalDailyStats.splice(0);
            this.totalDailyStats.push(...rsp.data.totalDailyStats);
            this.loading_chartandtotals=false;


            this.loading_physicaldevices=true;
            const rsp2 = await api.campaign.getCampaignProgressReportDataPartB(this.selectedCampaignID, {selectedStores: this.storeStatsFilter_selectedStores.map(s=>s.value), groupByDeviceType: this.groupByDeviceType, groupByStore: this.groupByStore, groupByDate: this.groupByDate});

            this.onlineAdpointsList.splice(0);
            this.onlineAdpointsList.push(...rsp2.data.onlineAdpointsList);

            this.storeAdpointStats.splice(0);
            this.storeAdpointStats.push(...rsp2.data.storeAdpointStats);
            this.loading_physicaldevices=false;
        } catch (error) {
            
        } finally {
            this.loading_chartandtotals=false;
            this.loading_physicaldevices=false;
        }
        
            */






        /*


        const rsp = await api.adpoint.getInitData();
        const rsp2 = await api.campaign.getOptionsRefList();
        this.campaignOptions = rsp2.data;
        const latestReleasedCampaign = rsp2.data.find(c=>c.text.includes('released'));
        if(latestReleasedCampaign) {
            //this.selectedCampaign = latestReleasedCampaign.value;
        }        
        else {
            if(rsp2.data.length>0) {
                this.selectedCampaign = rsp2.data[0].value;
            }
        }
        //this.networkOptions = rsp.data.networkOptions;
        this.networkOptions = [            
        ]
        this.deviceTypeOptions = rsp.data.deviceTypeOptions;
        this.brandOptions = rsp.data.brandOptions;
        this.attributeOptions = rsp.data.attributeOptions.map(i=> { return {...i, text: '['+i.value+'] ' + i.text}});
        if(this.networkOptions.length>0){
            this.selectedNetwork = this.networkOptions[0].value
        }        


        this.filterfields.push(
            {
                value: "brandId",
                text: "Brand",
                criteria: {},
                type: "list",
                listItems: this.brandOptions
            }
        );

        this.filterfields.push(
            {
                value: "deviceId",
                text: "Placement Type",
                criteria: {},
                type: "list",
                listItems: this.deviceTypeOptions
            },
        );







        this.fetchGridData();
        this.fetchGridData_adp();          
        
        */
    },
    async mounted() {
        
    }
}
</script>
<style lang="scss">
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}

</style>
